<template>
  <div class="row mt-2 g-3">
    <div class="col-12 col-md-12 col-xl-5">
      <div class="px-3 pt-3 shadow rounded-1">
        <div class="d-flex align-items-center">
          <span class="widget-icon me-3" style="height: auto">
            <i class="fa fa-user text-primary" />
          </span>
          <h3 class="m-0">Permohonan</h3>
        </div>
        <p class="fs-1">{{ dataPermohonan.jumlah_permohonan }}</p>
        <div class="row g-0 pb-3">
          <div
            role="button"
            class="col-6 col-lg-3"
            @click="toggleDetailPermohonanPersetujuan(true)"
          >
            <h5 class="m-0">{{ dataPermohonan.persetujuan }}</h5>
            <p class="text-secondary m-lg-0">Persetujuan</p>
          </div>
          <div
            role="button"
            class="col-6 col-lg-3"
            @click="toggleDetailPermohonanKonfirmasi(true)"
          >
            <h5 class="m-0">{{ dataPermohonan.konfirmasi }}</h5>
            <p class="text-secondary m-lg-0">Konfirmasi</p>
          </div>
          <div
            role="button"
            class="col-6 col-lg-3 border-left ps-2"
            @click="toggleDetailPermohonanBerusaha(true)"
          >
            <h5 class="m-0">{{ dataPermohonan.berusaha }}</h5>
            <p class="text-secondary m-0">Berusaha</p>
          </div>
          <div
            role="button"
            class="col-6 col-lg-3 ps-2"
            @click="toggleDetailPermohonanNonberusaha(true)"
          >
            <h5 class="m-0">{{ dataPermohonan.non_berusaha }}</h5>
            <p class="text-secondary m-0">Nonberusaha</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row g-3">
        <div class="col-12 col-md-6 col-lg-4">
          <div
            role="button"
            class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
            @click="toggleDetailPermohonanDokumenLengkap(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-check-square text-primary" />
              </span>
              <h3 class="m-0">Dokumen Lengkap</h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPermohonan.dokumen_lengkap }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div
            role="button"
            class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
            @click="toggleDetailPermohonanPerbaikanPersyaratan(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-file-text-o text-primary" />
              </span>
              <h3 class="m-0">Perbaikan Persyaratan</h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPermohonan.perbaikan_persyaratan }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div
            role="button"
            class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
            @click="toggleDetailPermohonanBelumVerdok(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-hourglass-half text-primary" />
              </span>
              <h3 class="m-0">Belum Verdok</h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPermohonan.menunggu_verdok }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div
            role="button"
            class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
            @click="toggleDetailPermohonanPenambahanKbli(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-file-text-o text-primary" />
              </span>
              <h3 class="m-0">Penambahan KBLI</h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPermohonan2.penambahan_kbli }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div
            role="button"
            class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
            @click="toggleDetailPermohonanIzinLokasi(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-file-text-o text-primary" />
              </span>
              <h3 class="m-0">Notifikasi Izin Lokasi</h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPermohonan2.notifikasi_izin_lokasi }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <DetailPermohonanPersetujuan
      :show="showDetailPermohonanPersetujuan"
      @close="toggleDetailPermohonanPersetujuan"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanKonfirmasi
      :show="showDetailPermohonanKonfirmasi"
      @close="toggleDetailPermohonanKonfirmasi"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanBerusaha
      :show="showDetailPermohonanBerusaha"
      @close="toggleDetailPermohonanBerusaha"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanNonberusaha
      :show="showDetailPermohonanNonberusaha"
      @close="toggleDetailPermohonanNonberusaha"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanDokumenLengkap
      :show="showDetailPermohonanDokumenLengkap"
      @close="toggleDetailPermohonanDokumenLengkap"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanPerbaikanPersyaratan
      :show="showDetailPermohonanPerbaikanPersyaratan"
      @close="toggleDetailPermohonanPerbaikanPersyaratan"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanBelumVerdok
      :show="showDetailPermohonanBelumVerdok"
      @close="toggleDetailPermohonanBelumVerdok"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanPenambahanKbli
      :show="showDetailPermohonanPenambahanKbli"
      @close="toggleDetailPermohonanPenambahanKbli"
      :filter-tahun="filterTahun"
    />
    <DetailPermohonanIzinLokasi
      :show="showDetailPermohonanIzinLokasi"
      @close="toggleDetailPermohonanIzinLokasi"
      :filter-tahun="filterTahun"
    />
  </div>
</template>

<script>
import DetailPermohonanPersetujuan from '../DetailDashboard/DetailPermohonanPersetujuan/DetailPermohonanPersetujuan.vue'
import DetailPermohonanKonfirmasi from '../DetailDashboard/DetailPermohonanKonfirmasi/DetailPermohonanKonfirmasi.vue'
import DetailPermohonanBerusaha from '../DetailDashboard/DetailPermohonanBerusaha.vue'
import DetailPermohonanNonberusaha from '../DetailDashboard/DetailPermohonanNonberusaha.vue'
import DetailPermohonanDokumenLengkap from '../DetailDashboard/DetailPermohonanDokumenLengkap/DetailPermohonanDokumenLengkap.vue'
import DetailPermohonanPerbaikanPersyaratan from '../DetailDashboard/DetailPermohonanPerbaikanPersyaratan/DetailPermohonanPerbaikanPersyaratan.vue'
import DetailPermohonanBelumVerdok from '../DetailDashboard/DetailPermohonanBelumVerdok/DetailPermohonanBelumVerdok.vue'
import DetailPermohonanPenambahanKbli from '../DetailDashboard/DetailPermohonanPenambahanKbli.vue'
import DetailPermohonanIzinLokasi from '../DetailDashboard/DetailPermohonanIzinLokasi.vue'
import axios from 'axios'

export default {
  components: {
    DetailPermohonanPersetujuan,
    DetailPermohonanKonfirmasi,
    DetailPermohonanBerusaha,
    DetailPermohonanNonberusaha,
    DetailPermohonanDokumenLengkap,
    DetailPermohonanPerbaikanPersyaratan,
    DetailPermohonanBelumVerdok,
    DetailPermohonanPenambahanKbli,
    DetailPermohonanIzinLokasi,
  },
  props: ['filterTahun'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      dataPermohonan: {
        jumlah_permohonan: 0,
        berusaha: 0,
        non_berusaha: 0,
        persetujuan: 0,
        konfirmasi: 0,
        dokumen_lengkap: 0,
        perbaikan_persyaratan: 0,
        menunggu_verdok: 0,
      },
      dataPermohonan2: {
        penambahan_kbli: 0,
        notifikasi_izin_lokasi: 0,
      },
      showDetailPermohonanPersetujuan: false,
      showDetailPermohonanKonfirmasi: false,
      showDetailPermohonanBerusaha: false,
      showDetailPermohonanNonberusaha: false,
      showDetailPermohonanDokumenLengkap: false,
      showDetailPermohonanPerbaikanPersyaratan: false,
      showDetailPermohonanBelumVerdok: false,
      showDetailPermohonanPenambahanKbli: false,
      showDetailPermohonanIzinLokasi: false,
    }
  },
  methods: {
    async loadDataPermohonan() {
      try {
        const res = await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPermohonan?tahun=${this.filterTahun}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        this.dataPermohonan = res.data.data
      } catch (error) {}
    },
    async loadDataPermohonan2() {
      try {
        const res = await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPenambahanNotif?tahun=${this.filterTahun}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        this.dataPermohonan2 = res.data.data
      } catch (error) {}
    },

    toggleDetailPermohonanPersetujuan(val) {
      this.showDetailPermohonanPersetujuan = val
    },
    toggleDetailPermohonanKonfirmasi(val) {
      this.showDetailPermohonanKonfirmasi = val
    },
    toggleDetailPermohonanBerusaha(val) {
      this.showDetailPermohonanBerusaha = val
    },
    toggleDetailPermohonanNonberusaha(val) {
      this.showDetailPermohonanNonberusaha = val
    },
    toggleDetailPermohonanDokumenLengkap(val) {
      this.showDetailPermohonanDokumenLengkap = val
    },
    toggleDetailPermohonanPerbaikanPersyaratan(val) {
      this.showDetailPermohonanPerbaikanPersyaratan = val
    },
    toggleDetailPermohonanBelumVerdok(val) {
      this.showDetailPermohonanBelumVerdok = val
    },
    toggleDetailPermohonanPenambahanKbli(val) {
      this.showDetailPermohonanPenambahanKbli = val
    },
    toggleDetailPermohonanIzinLokasi(val) {
      this.showDetailPermohonanIzinLokasi = val
    },
  },
  watch: {
    filterTahun: {
      handler(val) {
        this.loadDataPermohonan()
        this.loadDataPermohonan2()
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.h-auto {
  height: auto !important;
}

@media (min-width: 1200px) {
  .h-auto {
    height: 100% !important;
  }
}
</style>
